var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #4c4c4c;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.86,6.66c1.96,4.61,3.39,9.41,5.02,14.14.52,1.5-.13,2.82-1.16,3.92-1.08,1.15-2.16,2.31-3.33,3.36-1.32,1.19-1.49,2.32-.65,3.96,4.39,8.53,11.16,14.6,19.41,19.21,1.35.75,2.42.52,3.45-.57,1.13-1.2,2.31-2.35,3.5-3.49,1.16-1.11,2.6-1.72,4.14-1.17,4.7,1.69,9.55,2.98,14.12,5.06,2.25,2.99,2.18,7.13-.14,10.11-1.2,1.54-2.71,2.72-4.24,3.89-.3.2-.59.41-.89.61,0,0,0-.06,0-.06-6.85,3.2-13.58,2.43-20.05-.94-14.52-7.57-25.8-18.45-33.07-33.25-3.22-6.57-4.02-13.24-.48-20,1.3-1.89,2.67-3.71,4.6-5.04,2.97-2.05,7.02-1.94,9.77.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d030578cd4fcedaa26a32c5068826925.svg";
export { ForwardRef as ReactComponent };